export const generateDefaultQuestions = (program) => {
  const questions = [];
  const insured = program?.insured?.trim();
  const naics = program?.naics;
  const insuredAddress = program?.insuredAddress?.trim()?.replace(/\n/g, ", ");

  if (!insured) {
    return questions;
  }

  questions.push({
    query: `${insured} company overview and business operations`,
    itemType: "ai_query",
    label: "Company Overview",
  });

  questions.push({
    query: `${insured} recent news lawsuits regulatory actions`,
    itemType: "web_search",
    label: "News & Legal",
  });

  questions.push({
    query: `${insured} financial stability credit rating`,
    itemType: "web_search",
    label: "Financial Stability",
  });

  if (naics?.title) {
    questions.push({
      query: `${naics.title} industry risk factors and loss trends`,
      itemType: "ai_query",
      label: "Industry Risks",
    });
  }

  if (insuredAddress) {
    questions.push({
      query: `${insured} ${insuredAddress} location hazards and exposures`,
      itemType: "web_search",
      label: "Location Hazards",
    });
  }

  return questions;
};

export const hasDefaultsBeenRun = (sessionItems, defaultQuestions) => {
  if (
    !sessionItems ||
    sessionItems.length === 0 ||
    defaultQuestions.length === 0
  ) {
    return false;
  }
  const existingQueries = new Set(
    sessionItems.map((item) => item.query?.toLowerCase())
  );
  return defaultQuestions.every((q) =>
    existingQueries.has(q.query.toLowerCase())
  );
};
